<footer class="app-footer">
  <!-- <div class="footer-content">
    <p class="copyright"> -->
      © {{ currentYear }} Duke Energy Corporation. All rights reserved. | 
      <span class="app-info"> Oil Sample Custody Form Generator {{version}}</span>
    <!-- </p>
  </div> -->
</footer>
